const FIRST_WEEKDAY = 1;

export type Weekday = 1 | 2 | 3 | 4 | 5 | 6 | 7;

export const WEEKDAYS: readonly Weekday[] = [1, 2, 3, 4, 5, 6, 7];

export const weekdayRow = (weekday: number): number => weekday - FIRST_WEEKDAY;

export const weekdayInstant = (weekday: Weekday): Date => new Date(Date.UTC(2024, 0, weekday));
